import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  DropdownButton,
  Image,
  Dropdown,
  Button,
  Spinner,
  InputGroup,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import {
  getLevels,
  getTutors,
  getPostCodeName,
  getPostCode,
} from "./../apis/tutorList";
import { TutorListAction } from "./../redux/actions/index";
import { debounce } from "lodash";
import SearchSubject from "./../components/SearchSubject";

class TutorList extends Component {
  constructor() {
    super();

    this.state = {
      searchhistory: "",
      subject: "",
      focus: "",
      levels: [],
      levelValue: "",
      location: "",
      tutorList: [],
      loading: true,
      paginationpages: 1,
      errorMessage: "",
      show: false,
      postCodeArray: [],
      searchmode: false,
      postcodeLoader: false,
      adminDistrict: "",
      learnMore: "",
      listView: true,
    };
  }

  getPostCode = debounce((text) => {
    this.setState({
      postcodeLoader: true,
    });
    let isInputFieldEmptyRE = /^\s*$/;
    if (!isInputFieldEmptyRE.test(text)) {
      getPostCode({ text })
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              postCodeArray: response.result,
              searchmode: true,
              postcodeLoader: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            postcodeLoader: false,
          });
        });
    } else {
      this.setState({
        searchmode: false,
        postcodeLoader: false,
      });
    }
  }, 200);

  componentDidMount = () => {
    const { location } = this.props;
    let { paginateTutor, paginationpages } = this.state;
    getTutors({ search: location.search })
      .then((res) => {
        if (res?.data) {
          paginationpages = Math.ceil(res?.data.length / 5);
          paginateTutor = res?.data.filter((tutor, i) => i + 1 < 6);
          this.setState({
            tutorList: res?.data,
            loading: false,
            paginationpages,
            paginateTutor,
          });
        } else {
          this.setState({
            loading: false,
            paginateTutor: [],
          });
        }
      })
      .catch((err) => {
        console.log("res", err);
        this.setState({ loading: false });
      });
    let search = location.search.replace("?", "")?.split("&");
    if (search?.length === 4) {
      let searchMode = search[0]?.split("=")[1];
      let searchsubject = search[1]?.split("=")[1];
      let searchlevel = search[2]?.split("=")[1];
      let searchLocation = search[3]?.split("=")[1].replace("%20", " ");
      getPostCodeName({ searchLocation })
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              adminDistrict: "(" + response?.result[0]?.admin_district + ")",
            });
          }
        })
        .catch((err) => {});
      setTimeout(() => this.props.TutorListCheck(searchMode), 500);
      if (searchMode && searchsubject && searchlevel && searchLocation)
        this.setState({
          searchMode,
          searchsubject,
          searchlevel,
          searchLocation,
          location: searchLocation,
          subject: searchsubject,
          levelValue: searchlevel,
        });
      else
        this.setState({
          errorMessage: "Please specify all the missing fields",
        });
    } else {
      let searchMode = search[0]?.split("=")[1];
      let searchsubject = search[1]?.split("=")[1];
      let searchlevel = search[2]?.split("=")[1];
      if (searchMode && searchsubject && searchlevel) {
        setTimeout(() => this.props.TutorListCheck(searchMode), 500);

        this.setState({
          searchMode,
          searchsubject,
          searchlevel,
          searchLocation: "",
          subject: searchsubject,
          levelValue: searchlevel,
        });
      } else {
        this.setState({
          errorMessage: "Please specify all the missing fields",
        });
      }
    }

    getLevels()
      .then((res) => {
        this.setState({ levels: res.data });
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
  componentDidUpdate = (prevProps) => {
    let {
      location: { search },
    } = this.props;
    if (search !== prevProps.location.search) {
      search = search.replace("?", "")?.split("&");
      if (search?.length === 4) {
        let searchMode = search[0]?.split("=")[1];
        let searchsubject = search[1]?.split("=")[1];
        let searchlevel = search[2]?.split("=")[1];
        let searchLocation = search[3]?.split("=")[1].replace("%20", " ");
        getPostCodeName({ searchLocation })
          .then((response) => {
            if (response.status === 200) {
              this.setState({
                adminDistrict: "(" + response?.result[0]?.admin_district + ")",
              });
            }
          })
          .catch((err) => {});
        this.setState({
          searchMode,
          searchsubject,
          searchlevel,
          searchLocation,
          levelValue: searchlevel,
        });
      } else {
        let searchMode = search[0]?.split("=")[1];
        let searchsubject = search[1]?.split("=")[1];
        let searchlevel = search[2]?.split("=")[1];
        this.setState({
          searchMode,
          searchsubject,
          searchlevel,
          levelValue: searchlevel,
          searchLocation: "",
        });
      }
    }
  };

  goTosearchTutor = () => {
    const { subject, location, levelValue } = this.state;
    const { tutorListCheck } = this.props;
    const toogle = tutorListCheck !== "online" ? true : false;
    var regExpr = /^\s+$|^$/gi;

    if (
      (toogle ? !location?.match(regExpr) : true) &&
      levelValue &&
      !levelValue?.match(regExpr) &&
      subject &&
      !subject?.match(regExpr)
    ) {
      this.setState({ loading: true });
      this.props.history.push({
        pathname: "/tutors/search/",
        search: `?mode=${
          toogle === true ? "in-person" : "online"
        }&subject=${subject}&level=${levelValue}${
          toogle === true ? `&postCode=${location}` : ""
        }`,
      });
      getTutors({
        search: `?mode=${
          toogle === true ? "in-person" : "online"
        }&subject=${subject}&level=${levelValue}${
          toogle === true ? `&postCode=${location}` : ""
        }`,
      })
        .then((res) =>
          this.setState({
            paginateTutor: res?.data.filter((tutor, i) => i + 1 < 6),
            tutorList: res.data,
            loading: false,
            errorMessage: "",
          })
        )
        .catch((err) => this.setState({ loading: false }));
    } else {
      this.setState({
        errorMessage: "Please specify all the missing fields",
      });
    }
  };

  handlePageClick = (data) => {
    let { tutorList, paginateTutor } = this.state;
    let selected = data.selected + 1;
    let start = selected * 5 - 4;
    let end = selected * 5;
    paginateTutor = tutorList.filter((value, i) => start <= i && end >= i);
    this.setState({ page: selected, paginateTutor });
  };
  onToggle = () => {
    const { show } = this.state;
    if (!show) {
      this.setState({
        focus: "",
      });
    }
    this.setState({ show: !show });
  };
  onFocusfield = (e, focus) => {
    e.stopPropagation();
    this.setState({
      focus,
    });
  };
  onLearnMoreArray = (e, userId) => {
    e.stopPropagation();
    this.props.history.push(`/tutors/search/tutor/${userId}/learn-more`);
    // index || index === 0
    //   ? this.setState({
    //       learnMore: index,
    //     })
    //   : this.setState({
    //       learnMore: "",
    //     });
  };
  getSubjectValue = (value) => {
    let subAndLev = value.split("(");
    if (subAndLev.length > 1) {
      let subject = subAndLev[0].substring(0, subAndLev[0].length - 1);
      let level = subAndLev[1].substring(0, subAndLev[1].length - 1);
      this.setState({ subject: subject, levelValue: level, errorMessage: "" });
    } else {
      this.setState({ subject: value, levelValue: "", errorMessage: "" });
    }
  };
  render() {
    const {
      focus,
      levels,
      levelValue,
      searchsubject,
      searchlevel,
      tutorList,
      loading,
      searchLocation,
      paginateTutor,
      paginationpages,
      errorMessage,
      location,
      subject,
      show,
      postCodeArray,
      searchmode,
      postcodeLoader,
      adminDistrict,
      learnMore,
      listView,
    } = this.state;
    const { tutorListCheck } = this.props;
    const toogle = tutorListCheck !== "online" ? true : false;
    console.log(paginateTutor?.length);
    return (
      <div className="container">
        <Row
          className="tutor-list-Row"
          onClick={() =>
            this.setState({
              focus: "",
            })
          }
        >
          {/* <Col lg={1} md={1}></Col> */}
          <Col
            lg={12}
            sm={12}
            md={12}
            xs={12}
            // md={toogle ? 10 : 8}
            // lg={toogle ? 8 : 6}
            className="TutorList-Head_Col"
            style={{ display: "none" }}
          >
            {toogle && (
              <span
                className={
                  focus === "postCode"
                    ? "search-subject-col-selected"
                    : "search-subject-col"
                }
                style={{ flex: toogle ? "1" : "2" }}
              >
                <Form.Group
                  controlId="formBasicEmail"
                  className="flex-start-center"
                >
                  <InputGroup>
                    {/* <Form.Label>Post Code</Form.Label> */}
                    <Form.Control
                      type="text"
                      onClick={(e) => this.onFocusfield(e, "postCode")}
                      placeholder="Add your postcode"
                      onChange={(e) => {
                        this.getPostCode(e.target.value);
                        this.setState({ location: e.target.value });
                      }}
                      value={location}
                    />
                    <InputGroup.Append
                      style={{
                        border: "none",
                        padding: "0 3px",
                      }}
                      className="flex-center-center"
                    >
                      {location ? (
                        <span
                          className="cross-style"
                          onClick={(e) => {
                            this.setState({
                              location: "",
                            });
                            this.getPostCode("");
                          }}
                        >
                          x
                        </span>
                      ) : (
                        ""
                      )}
                    </InputGroup.Append>
                  </InputGroup>
                </Form.Group>
                <div
                  style={{
                    display:
                      postcodeLoader || (postCodeArray?.length && searchmode)
                        ? "flex"
                        : "none",
                  }}
                  className="postcode-list-div"
                >
                  {!postcodeLoader ? (
                    searchmode && postCodeArray?.length ? (
                      postCodeArray.map((post, map) => (
                        <p
                          key={map}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.setState({
                              location: post,
                              searchmode: false,
                              postCodeArray: [],
                            })
                          }
                        >
                          <div className="flex-start-center post-value">
                            <Image
                              style={{
                                width: "15px",
                                marginRight: "5px",
                                marginBottom: "2px",
                              }}
                              src={require("./../assets/icons/gps.png")}
                            />
                            <span>{post}</span>
                          </div>
                        </p>
                      ))
                    ) : (
                      "no post code"
                    )
                  ) : (
                    <div className="flex-center-center">
                      <Spinner
                        animation="border"
                        style={{ width: "25px", height: "25px" }}
                      />
                    </div>
                  )}
                </div>
              </span>
            )}
            <span
              className={
                focus === "subject"
                  ? "search-subject-col-selected"
                  : "search-subject-col"
              }
              style={{ flex: toogle ? "1" : "2" }}
            >
              <Form.Group
                controlId="formBasicEmail"
                className="flex-start-center"
              >
                {/* <Form.Label>Subject</Form.Label> */}
                {/* <Form.Control
                  type="text"
                  placeholder="Add Subject"
                  onClick={(e) => this.onFocusfield(e, "subject")}
                  onChange={(e) => this.setState({ subject: e.target.value })}
                  value={subject}
                /> */}
                <SearchSubject
                  subjectValue={subject}
                  getSubjectValue={(value) => this.getSubjectValue(value)}
                  onClick={(e) => this.onFocusfield(e, "subject")}
                  // searchStyle={{ top: "96px" }}
                />
              </Form.Group>
            </span>
            <div
              className={`dropdownlevel flex-start-center ${
                show ? "search-subject-col-selected" : ""
              }`}
              style={{ flex: toogle ? "1" : "2" }}
            >
              {/* <div className="level-title">Level</div> */}
              <DropdownButton
                id="dropdown-basic-button"
                show={show}
                onToggle={this.onToggle}
                title={
                  <span className="flex-between-center">
                    <span className="search-date" style={{ display: "grid" }}>
                      <span className="truncate">
                        {levelValue ? levelValue : "No Selected"}
                      </span>
                    </span>
                    {/* <Image
                      style={{ width: "10px" }}
                      src={require("./../assets/icons/down-arrow.png")}
                    /> */}
                  </span>
                }
              >
                {levels && levels.length ? (
                  levels.map((level, index) => {
                    return (
                      <Dropdown.Item
                        onClick={() => this.setState({ levelValue: level })}
                        key={index}
                      >
                        {level}
                      </Dropdown.Item>
                    );
                  })
                ) : (
                  <Dropdown.Item>No Data</Dropdown.Item>
                )}
              </DropdownButton>
            </div>
            <div
              className="search-div flex-center-center"
              style={{ width: toogle ? "25%" : "33%" }}
            >
              <Button
                className="flex-center-center"
                onClick={this.goTosearchTutor}
              >
                <Image
                  src={require("./../assets/icons/search-white.png")}
                  style={{ width: "28.4px", marginRight: "7px" }}
                />
                Search
              </Button>
            </div>
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0px" }}>
            {!errorMessage ? 
              ( 
                <div className="body-steps">
                  { tutorList?.length ? tutorList?.length : 0 } tutors
                  { searchsubject ? <span className="dot"></span> : "" }{ searchsubject ? searchsubject : "" }
                  { searchlevel ? <span className="dot"></span> : "" }{ searchlevel ? searchlevel : "" }
                  { searchLocation ? <span className="dot"></span> : "" }{ searchLocation ? searchLocation : "" }
                  <span className="dot"></span>{ searchLocation == "" ? "Online" : "In-person"}
                </div>
              ) : "" 
            }
            <div className="body-title">
              <h2>
                {errorMessage
                  ? errorMessage
                  : `${searchlevel ? searchlevel : ""} ${
                      searchsubject ? searchsubject : ""
                    } tutors, ${searchLocation ? searchLocation : ""} ${
                      toogle ? (adminDistrict ? adminDistrict : "") : ""
                    } `}
              </h2>
              <div className="flex-between-center">
                <div className="tutor-top-listbtn">
                  <Button>Price</Button>
                  <Button>Availability</Button>
                  <Button>Background Check</Button>
                  <Button>Qualification</Button>
                </div>
                <button 
                  className="menu-style" 
                  onClick={() => this.setState({ listView: !listView })}
                >
                  <i className={ listView ? "fa fa-list" : "fa fa-th" }></i>
                  <span> { listView ? "List" : "Grid" } View</span>
                </button>
              </div>
            </div>
            {
              paginateTutor?.length || loading?(
                <div style={{ borderBottom: "1px solid #00000033", margin: "15px 0 0 0" }}/>
              ) : ""
            }
            <Col lg={12} md={12} sm={12} xs={12} className="body-content">
            {loading ? (
                <div className="flex-center-center">
                  <Spinner
                    animation="border"
                    style={{ width: "35px", height: "35px", margin: "15px 0" }}
                  />
                </div>
              ) : paginateTutor?.length ? ( <div className={ listView? "row" : "" }>
                {paginateTutor.map((value, index) => {
                value.subjectName = subject;
                value.levelName = levelValue;
                return (
                  <React.Fragment>
                    { !listView ? 
                      (
                        <div className="row tutor-card"
                          onClick={() => {
                            this.props.history.push(
                              `/tutors/search/tutor/${value.userId}`
                            );
                            this.props.TutorSpecificDataAction(value);
                          }}
                          >
                          <div className="col">
                              <div className="row">
                                <div className="col-lg-9 col-md-8 col-xs-12">
                                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <span>
                                    <span className="online">ONLINE</span>
                                      <span className="tutors-name">{`${
                                        value.firstName
                                      } ${value.lastName
                                        .substring(0, 1)
                                        .toUpperCase()}.`}</span>
                                    </span>
                                    <span className="tutor-rating">
                                      <img className="star" src={require('./../assets/icons/star1.png')} alt="star1"></img>
                                      <span className="Rating">5.0<span className="Number">(152)</span></span>
                                    </span>
                                  </div>
                                  <div className="tutor-info">
                                      <p className="tutor-title">{value?.tutorDetail?.tagline}</p>
                                      <p className="tutor-online">Online tutor</p>
                                  </div>
                                  <div className="tutor-details">
                                      <p className="tutor-detail-head">My teaching style:</p>
                                      <p className="tutor-detail-body">
                                        {value?.tutorDetail?.teachingStyle
                                          ? value?.tutorDetail.teachingStyle
                                          : ""}</p>
                                      <p className="From-20hour">{`From £${value?.tutorDetail.hourlyRate}/hour`}</p>
                                  </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-xs-12">
                                  <img style={{ marginBottom: "20px" }} src={value?.imageUrl
                                        ? value?.imageUrl
                                        : "https://firebasestorage.googleapis.com/v0/b/askademia-36826.appspot.com/o/no-img.png?alt=media&token=139f8f26-4fa9-4cdf-88d7-a27859180a12"
                                        } alt={`${
                                          value.firstName
                                        } ${value.lastName
                                          .substring(0, 1)
                                          .toUpperCase()}.`} className="tutor-card-img"/>
                                </div>
                              </div>
                          <div style={{ borderBottom: "1px solid #00000033", margin: "15px 0 0 0" }}/>
                          </div>
                          </div>                   
                      ) :
                      (
                        <Col lg={3} xs={6} className="coloumns"
                          onClick={() => {
                            this.props.history.push(
                              `/tutors/search/tutor/${value.userId}`
                            );
                            this.props.TutorSpecificDataAction(value);
                          }}
                        >
                          <div className="card coloumn">
                              <img className="image" src={value?.imageUrl
                                        ? value?.imageUrl
                                        : "https://firebasestorage.googleapis.com/v0/b/askademia-36826.appspot.com/o/no-img.png?alt=media&token=139f8f26-4fa9-4cdf-88d7-a27859180a12"
                                        } alt={`${
                                          value.firstName
                                        } ${value.lastName
                                          .substring(0, 1)
                                          .toUpperCase()}.`}></img>
                              <div className="Rectangle-48">ONLINE</div>
                              <div className="body">
                                  <div className="Name">{`${
                                        value.firstName
                                      } ${value.lastName
                                        .substring(0, 1)
                                        .toUpperCase()}.`}</div>
                                  <div className="Subjects">Maths <span className="dot"></span> Physics <span className="dot"></span> Biology</div>
                                  <div className="per-hour">{`£${value?.tutorDetail.hourlyRate} per hour`}</div>
                                  <div>
                                      <img src={require("./../assets/icons/star1.png")} alt="star1" style={{width: "10px",height:'10px'}}></img>
                                      <span className="Rating">5.0<span className="Number">(152)</span></span>
                                  </div>
                              </div>
                          </div>
                      </Col>
                      )
                    }
                  </React.Fragment>
               );})}</div>
              ) : (
                <div className="no-result">
                  <h5>No results</h5>
                  <p>To more results, try adjusting your search by changing or removing your filters</p>
                </div>
              )}
            </Col>
            { paginateTutor?.length ? 
              (
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="flex-center-center pagnination-Col"
                >
                  <ReactPaginate
                    previousLabel={
                      <span>
                        <Image
                          style={{ transform: "rotate(180deg)", width: "18px" }}
                          src={require("./../assets/icons/next-black.png")}
                        />
                      </span>
                    }
                    nextLabel={
                      <span>
                        <Image
                          style={{ transform: "rotate(0deg)", width: "18px" }}
                          src={require("./../assets/icons/next-black.png")}
                        />
                      </span>
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={1}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                  />
                </Col>
              ) : ""
            }
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    TutorListReducer: { tutorListCheck },
    UserReducer: { user },
  } = state;

  return {
    tutorListCheck,
    user,
  };
};
const mapDispatchToprops = (dispatch) => {
  return {
    TutorListCheck: (payload) =>
      dispatch(TutorListAction.TutorListCheck(payload)),
    TutorSpecificDataAction: (payload) =>
      dispatch(TutorListAction.TutorSpecificDataAction(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(TutorList);
